import { useThemeColors } from '@codezo/theme';
import { AppShell, Box } from '@mantine/core';
import { Outlet, useNavigate } from 'react-router-dom';
import { Logo } from '../components/common/Logo';

export function SignupLayout() {
	const colors = useThemeColors();
	const navigate = useNavigate();

	return (
		<AppShell
			styles={{
				main: {
					backgroundColor: colors.background,
					minHeight: '100vh',
					padding: 0,
				},
			}}
		>
			<AppShell.Main>
				{/* Logo absolute positioned for larger screens (992px+) */}
				<Box
					display={{ base: 'none', md: 'block' }}
					pos="absolute"
					top={32}
					left={32}
					style={{ zIndex: 1000 }}
				>
					<Logo onClick={() => navigate('/')} height={32} />
				</Box>

				<Outlet />
			</AppShell.Main>
		</AppShell>
	);
}
